//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import {
  useFetchTicketProviderTicketChildrenQuery,
} from 'api/ticketProviderTickets'

import { RouteTicketProviderTicket } from 'routes'

import colors from 'components/utils/colors'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import Spinner from 'components/Shared/Spinner/Index'
import TableCells from './TableCells'

const MatchInfoTableCell = styled(TableCell)`
  background-color: ${colors.secondary90};
`

const SpinnerWrapper = styled.div`
  display: flex;
  padding-left: 12px;
`

const ExpandedRowChildren = ({ ticket }) => {
  const { t } = useTranslation()
  const { data, isFetching } = useFetchTicketProviderTicketChildrenQuery({
    ticketProviderId: ticket.ticketProviderId,
    parentTicketId: ticket.id,
    perPage: 50,
  })

  const tickets = data?.tickets || []
  const partnerStatusesMap = data?.partnerStatusesMap || {}

  if (isFetching) {
    return (
      <TableRow key={`fetching_${ticket.id}`} hoverable={false} clickable={false}>
        <MatchInfoTableCell colSpan='100%'>
          <SpinnerWrapper>
            {t('common.loading')}
            <Spinner size={16} />
          </SpinnerWrapper>
        </MatchInfoTableCell>
      </TableRow>
    )
  }

  return (
    <>
      {tickets.map(ticket => {
        const statusName = ticket.status
        const statusColor = partnerStatusesMap[statusName]?.color

        const ticketUrl = RouteTicketProviderTicket({
          ticketProviderId: ticket.ticketProviderId,
          ticketId: ticket.externalId,
        })

        return (
          <TableRow
            key={ticket.id}
            color={statusColor}
          >
            <TableCells
              ticket={ticket}
              ticketUrl={ticketUrl}
              partnerStatusesMap={partnerStatusesMap}
              withExpandableRows={false}
              isInChildRow
            />
          </TableRow>
        )
      })}
    </>
  )
}

ExpandedRowChildren.propTypes = {
  ticket: PropTypes.object.isRequired,
}

export default ExpandedRowChildren
